import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    CloseButton,
} from "@chakra-ui/react";

import React from "react";

export const CustomAlert = ({ text, message, status }) => {
    return (
        <Alert status={status || "error"}>
            <AlertIcon />
            <AlertTitle mr={2}>{text}</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
        </Alert>
    );
};
